import { Subcategory } from '@core/models';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import {
  SUBCATEGORY_FIND,
  SUBCATEGORY_FAILED,
  SUBCATEGORY_UPDATE_LOADING,
  SUBCATEGORY_FIND_ALL_SUCCESS,
  SUBCATEGORY_UPDATE_ID,
} from '../actions';
import { SubcategoryService } from '@core/services/subcategory/subcategory.service';
import { Store } from '@ngrx/store';
import { selectLocalChannelId, selectMenu } from '../selectors';

@Injectable()
export class SubcategoryEffects {
  localChannelId$: Observable<string | null>;

  constructor(
    private actions$: Actions,
    private subsubcategoryService: SubcategoryService,
    private store: Store
  ) {
    this.localChannelId$ = this.store.select(selectLocalChannelId);
  }

  find$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SUBCATEGORY_FIND),
      withLatestFrom(
        this.store.select(selectLocalChannelId),
        this.store.select(selectMenu)
        ),
      map(([_, localChannelId, menu]) => {
        return { localChannelId: localChannelId as string, menu };
      }),
      filter(({ localChannelId, menu }) => !!localChannelId && !!menu),
      mergeMap(({ localChannelId, menu }) => {
        this.store.dispatch(SUBCATEGORY_UPDATE_LOADING({ loading: true }));
        return this.subsubcategoryService.getSubcategories(localChannelId,menu).pipe(
          mergeMap(({ data }) => {
            const subcategoryList: Subcategory[] = data;
            const [{ idSubcategoria: subcategoryId }] = subcategoryList ?? [];

            return [
              SUBCATEGORY_FIND_ALL_SUCCESS({ subcategoryList }),
              SUBCATEGORY_UPDATE_ID({ subcategoryId }),
              SUBCATEGORY_UPDATE_LOADING({ loading: false }),
            ];
          }),
          catchError((error) =>
            of(
              SUBCATEGORY_UPDATE_LOADING({ loading: false }),
              SUBCATEGORY_FAILED({
                error: error.error?.message || 'Error loading categories',
              })
            )
          )
        );
      })
    )
  );
}
